export default function Timeline() {
  const timeline = document.querySelector('.timeline-block');
  const timelineContent = document.querySelector('.timeline-block__content');

  if (!timeline || !timelineContent) {
    return;
  }


  const timelinePosts = timeline.querySelectorAll('.timeline-block__post');
  const timelineLine = document.querySelector('.timeline-block__line');
  const timelineMargin = 48;
  const timelinePaddingLeft = 20
  const timelineControls = timeline.querySelectorAll('.timeline-block__control');
  const timelineFirstPost = timeline.querySelectorAll('.timeline-block__post--future')[0];

  setTimelinePosition();

  if (timelineFirstPost) {
    timelineContent.scrollLeft = timelineFirstPost.offsetLeft - timelinePaddingLeft;
  }

  window.addEventListener('resize', () => {
    resetTimelinePosition();
    setTimelinePosition();
  });

  timelineControls.forEach(timelineControl => {
    timelineControl.addEventListener('click', () => scrollTimeline(timelineControl.dataset.direction));
  });

  function setTimelinePosition() {
    let timelineHeight = document.querySelector('.timeline-block__content').offsetHeight;

    timelineLine.style.marginTop = (timelineHeight + timelineMargin / 2) + 'px';

    timelinePosts.forEach((post, index) => {
      if (index % 2 != 0) {
        post.style.marginTop = (timelineHeight + timelineMargin + 2) + 'px';
      } else {
        post.style.marginTop = (timelineHeight - post.offsetHeight) + 'px';
      }
    });
  };

  function resetTimelinePosition() {
    timelineLine.style.marginTop = 0;

    timelinePosts.forEach((post) => {
      post.style.marginTop = 0;
    });
  };

  function scrollTimeline(direction) {
    let scrollPosition = timelineContent.scrollLeft;
    let postWidth = timelinePosts[0].offsetWidth - 120;

    direction === 'next' ?
      timelineContent.scrollLeft = scrollPosition + postWidth : timelineContent.scrollLeft = scrollPosition - postWidth;
  };

}
;
